(function (factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else api.start();
})(function () {
  'use strict';
  var calendar = {"source":"https://www.gov.uk/bank-holidays.json","checked":"2026-10-31","validFrom":"2026-01-01","validUntil":"2028-12-31","dispatchHolidays":["2026-01-01","2026-01-02","2026-04-03","2026-05-04","2026-05-25","2026-06-15","2026-08-03","2026-11-30","2026-12-25","2026-12-28","2027-01-01","2027-01-04","2027-03-26","2027-05-03","2027-05-31","2027-08-02","2027-11-30","2027-12-27","2027-12-28","2028-01-03","2028-01-04","2028-04-14","2028-05-01","2028-05-29","2028-08-07","2028-11-30","2028-12-25","2028-12-26"],"deliveryHolidays":["2026-01-01","2026-01-02","2026-03-17","2026-04-03","2026-04-06","2026-05-04","2026-05-25","2026-06-15","2026-07-13","2026-08-03","2026-08-31","2026-11-30","2026-12-25","2026-12-28","2027-01-01","2027-01-04","2027-03-17","2027-03-26","2027-03-29","2027-05-03","2027-05-31","2027-07-12","2027-08-02","2027-08-30","2027-11-30","2027-12-27","2027-12-28","2028-01-03","2028-01-04","2028-03-17","2028-04-14","2028-04-17","2028-05-01","2028-05-29","2028-07-12","2028-08-07","2028-08-28","2028-11-30","2028-12-25","2028-12-26"]};
  var dayMs = 86400000;
  function addDays(key, count) {
    return new Date(Date.parse(key + 'T12:00:00Z') + count * dayMs).toISOString().slice(0, 10);
  }
  function londonParts(now) {
    var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' }).formatToParts(now);
    var values = {};
    parts.forEach(function (part) { values[part.type] = part.value; });
    return { key: values.year + '-' + values.month + '-' + values.day, hour: Number(values.hour) };
  }
  function validDay(key, saturday, holidays) {
    var day = new Date(key + 'T12:00:00Z').getUTCDay();
    return day !== 0 && (saturday || day !== 6) && !holidays.has(key);
  }
  function advance(key, count, saturday, holidays) {
    for (var limit = 0; count > 0 && limit < 370; limit++) {
      key = addDays(key, 1);
      if (validDay(key, saturday, holidays)) count--;
    }
    return count > 0 ? null : key;
  }
  function estimate(now, config, source) {
    source = source || calendar;
    config = config || {};
    var local = londonParts(now);
    if (local.key < source.validFrom || local.key > source.validUntil) return null;
    var cutoff = Number(config.cutoffHour);
    if (!Number.isFinite(cutoff) || cutoff < 0 || cutoff > 23) cutoff = 12;
    var dispatchHolidays = new Set(source.dispatchHolidays);
    String(config.closures || '').split(/[\s,]+/).filter(function (key) { return /^\d{4}-\d{2}-\d{2}$/.test(key); }).forEach(function (key) { dispatchHolidays.add(key); });
    var deliveryHolidays = new Set(source.deliveryHolidays);
    var dispatch = local.key;
    if (local.hour >= cutoff || !validDay(dispatch, false, dispatchHolidays)) dispatch = advance(dispatch, 1, false, dispatchHolidays);
    if (!dispatch) return null;
    var standardStart = advance(dispatch, 2, true, deliveryHolidays);
    var standardEnd = advance(dispatch, 3, true, deliveryHolidays);
    var express = advance(dispatch, 1, true, deliveryHolidays);
    if (!dispatch || !standardStart || !standardEnd || !express || standardEnd > source.validUntil) return null;
    return { today: local.key, dispatch: dispatch, standardStart: standardStart, standardEnd: standardEnd, express: express, cutoff: cutoff, sameDay: dispatch === local.key };
  }
  function formatDate(key) {
    return new Intl.DateTimeFormat('en-GB', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' }).format(new Date(key + 'T12:00:00Z'));
  }
  function start() {
    if (window.FRDeliveryEstimate) { window.FRDeliveryEstimate.boot(document); return; }
    var instances = new Map();
    function boot(scope) {
      (scope || document).querySelectorAll('.frp[data-frp-version="7.0"]').forEach(function (root) {
        if (instances.has(root)) return;
        var panel = root.querySelector('[data-fr-delivery]');
        if (!panel) return;
        var config;
        try { config = JSON.parse(panel.querySelector('[data-fr-delivery-config]').textContent); } catch (error) { return; }
        var controller = new AbortController();
        var opts = { signal: controller.signal };
        var available = config.available !== false;
        var labels = config.labels;
        function render() {
          panel.querySelector('[data-fr-delivery-available]').hidden = !available;
          panel.querySelector('[data-fr-delivery-unavailable]').hidden = available;
          if (!available) return;
          var result;
          try { result = estimate(new Date(), config); } catch (error) { result = null; }
          var dispatch = panel.querySelector('[data-fr-dispatch]');
          var standard = panel.querySelector('[data-fr-standard]');
          var express = panel.querySelector('[data-fr-express]');
          var note = panel.querySelector('[data-fr-delivery-note]');
          if (!result) {
            dispatch.textContent = labels.dispatch;
            standard.textContent = labels.standard;
            express.textContent = labels.express;
            note.textContent = "";
            note.hidden = true;
            return;
          }
          var relative = result.dispatch === result.today ? labels.today : result.dispatch === addDays(result.today, 1) ? labels.tomorrow : '';
          dispatch.textContent = (relative ? relative + ' · ' : '') + formatDate(result.dispatch);
          standard.textContent = formatDate(result.standardStart) + ' – ' + formatDate(result.standardEnd);
          express.textContent = formatDate(result.express);
          var cutoff = result.cutoff === 12 ? '12pm' : result.cutoff > 12 ? (result.cutoff - 12) + 'pm' : result.cutoff === 0 ? '12am' : result.cutoff + 'am';
          note.textContent = result.sameDay ? labels.cutoff.replace('[time]', cutoff) : '';
          note.hidden = !result.sameDay;
        }
        document.addEventListener('frp:variant-change', function (event) {
          if (event.detail && event.detail.sid === root.dataset.sectionId) {
            available = event.detail.variant.available !== false;
            render();
          }
        }, opts);
        document.addEventListener('visibilitychange', function () { if (!document.hidden) render(); }, opts);
        window.addEventListener('pageshow', render, opts);
        var interval = setInterval(render, 60000);
        instances.set(root, function () { controller.abort(); clearInterval(interval); instances.delete(root); });
        render();
      });
    }
    window.FRDeliveryEstimate = { boot: boot };
    document.addEventListener('shopify:section:load', function (event) { boot(event.target); });
    document.addEventListener('shopify:section:unload', function (event) {
      event.target.querySelectorAll('.frp[data-frp-version="7.0"]').forEach(function (root) { if (instances.has(root)) instances.get(root)(); });
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
    else boot(document);
  }
  return { estimate: estimate, londonParts: londonParts, addDays: addDays, calendar: calendar, start: start };
});
